import { Injectable, inject } from "@angular/core";
import { getLocalStorage } from "../../local-storage";
import { Auth, user } from "@angular/fire/auth";
import { UsuariosService } from "../catalogos/usuarios/usuarios.service";
import { of, switchMap } from "rxjs";
import {
  Database,
  listVal,
  objectVal,
  onValue,
  ref,
} from "@angular/fire/database";
import { Router } from "@angular/router";
import { AppState } from "../../app.state";
import { select, Store } from "@ngrx/store";
import { selectUsuario } from "../../states/usuario/selector";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private isAuthenticated: boolean = false;

  private database: Database = inject(Database);
  public readonly store: Store<AppState> = inject(Store);
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  private auth: Auth = inject(Auth);
  private user$ = user(this.auth);

  constructor(
    private usuariosService: UsuariosService,
    private router: Router
  ) {
    const localStorage = getLocalStorage();
    this.isAuthenticated = !!localStorage;
  }

  getUsuarioA() {
    return this.user$.pipe(
      switchMap(async (aUser) =>
        !aUser ? of(null) : this.listenForRoleChanges(aUser.uid)
      )
    );
  }

  isAuthenticatedd(): boolean {
    return this.isAuthenticated;
  }

  login(username: string, password: string): void {
    this.isAuthenticated = true;
    const localStorage = getLocalStorage();
    localStorage?.setItem("user", username);
    this.usuariosService
      .getUser(this.auth.currentUser?.uid || "")
      .subscribe((user) => {
        console.log("user", user);
      });
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.removeItem("user");
  }

  private listenForRoleChanges(uid: string) {
    const userRef = ref(this.database, `usuarios/${uid}`);

    onValue(userRef, (snapshot) => {
      const userData = snapshot.val();

      const user = structuredClone(this.stateUser.state().usuario);
      console.log("this.auth.currentUser", this.auth.currentUser);

      if (
        userData &&
        userData.rol &&
        user &&
        user.rol &&
        user.rol > 0 &&
        this.auth.currentUser
      ) {
        const userRole = userData.rol;
        console.log("userRole", userRole);
        console.log("user.rol", user.rol);

        if (userRole !== user.rol) {
          this.signOut();
        }
      }
    });
  }

  private async signOut() {
    if (!window.location.href.includes("login")) {
      await this.auth.signOut();
      this.router.navigate(["/login"]);
    }
  }
}
